import React, { useEffect, useState } from 'react';
import API from '../services/api';
import './StudentPages.css';

const StudentProfilePage = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    API.get('/portal/dashboard').then(res => setData(res.data)).catch(console.error);
  }, []);

  if (!data) return <div className="s-loading">Loading...</div>;

  const { student, overallStats, readiness } = data;

  const getReadinessLabel = (level) => {
    const map = { 'top_performer': 'Top Performer', 'placement_ready': 'Placement Ready', 'moderate': 'Moderate', 'needs_improvement': 'Needs Improvement' };
    return map[level] || 'Not evaluated yet';
  };

  return (
    <>
      <div className="profile-page-content">
        <div className="s-page-header">
          <h2>My Profile</h2>
          <p>Your academic and performance details</p>
        </div>

        <div className="s-profile-top">
          <div className="s-profile-avatar">{student.name?.[0]?.toUpperCase()}</div>
          <div className="s-profile-info">
            <h3>{student.name}</h3>
            <p>{student.roll_number} · {student.branch} {student.year_of_study ? `(Year ${student.year_of_study})` : ''} · Batch {student.placement_batch_year || '—'}</p>
            <p>{student.email}</p>
            <span className={`s-placement-badge ${student.placement_status?.replace(' ', '-')}`}>
              {student.placement_status}
            </span>
          </div>
        </div>

        <div className="s-profile-grid">
          <div className="s-info-card">
            <div className="s-info-title">Academic Details</div>
            <div className="s-info-row"><span>CGPA</span><strong>{student.cgpa || '—'}</strong></div>
            <div className="s-info-row"><span>Arrears</span>
              <strong style={{ color: student.arrears > 0 ? '#e94560' : '#16a085' }}>
                {student.arrears ?? 0}
              </strong>
            </div>
            <div className="s-info-row"><span>Branch</span><strong>{student.branch || '—'}</strong></div>
            <div className="s-info-row"><span>Year of Study</span><strong>{student.year_of_study || '—'}</strong></div>
            <div className="s-info-row"><span>Placement Batch</span><strong>{student.placement_batch_year || '—'}</strong></div>
          </div>

          <div className="s-info-card">
            <div className="s-info-title">Performance Summary</div>
            <div className="s-info-row"><span>Tests Taken</span><strong>{overallStats?.tests_taken || 0}</strong></div>
            <div className="s-info-row"><span>Total Correct</span><strong style={{ color: '#16a085' }}>{overallStats?.total_correct || 0}</strong></div>
            <div className="s-info-row"><span>Total Wrong</span><strong style={{ color: '#e94560' }}>{overallStats?.total_wrong || 0}</strong></div>
            <div className="s-info-row"><span>Avg Score</span><strong>{parseFloat(overallStats?.avg_score || 0).toFixed(1)}%</strong></div>
          </div>

          {readiness && (
            <div className="s-info-card readiness">
              <div className="s-info-title">Placement Readiness</div>
              <div className="readiness-level">{getReadinessLabel(readiness.readiness_level)}</div>
              <div className="readiness-score">Overall: {parseFloat(readiness.overall_score).toFixed(1)}%</div>
              <div className="readiness-breakdown">
                {[
                  { label: 'Quantitative', val: readiness.quant_score },
                  { label: 'Logical',      val: readiness.logical_score },
                  { label: 'Verbal',       val: readiness.verbal_score },
                ].map((r, i) => (
                  <div key={i} className="r-row">
                    <span>{r.label}</span>
                    <div className="r-bar-bg">
                      <div className="r-bar" style={{ width: `${r.val}%`, background: '#e94560' }} />
                    </div>
                    <span>{parseFloat(r.val || 0).toFixed(0)}%</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default StudentProfilePage;